/**
 * Branch Information Service
 * 
 * This dedicated service handles operations specifically for branch information
 * to isolate and fix the issue with saving branch info in invoice pages.
 */

// Direct API calls with detailed logging
export const updatePageBranchInfo = async (pageId, branchInfo) => {
  console.log(`[BranchInfoService] Updating branch info for page ${pageId}`, branchInfo);
  
  // Create a clean branch info object with all expected fields
  const cleanBranchInfo = {
    branchName: branchInfo.branchName || '',
    companyName: branchInfo.companyName || '',
    commercialRegister: branchInfo.commercialRegister || '',
    branchAddress: branchInfo.branchAddress || '',
    phoneNumber: branchInfo.phoneNumber || '',
    taxNumber: branchInfo.taxNumber || '',
    street: branchInfo.street || '',
    buildingNumber: branchInfo.buildingNumber || '',
    postalCode: branchInfo.postalCode || '',
    city: branchInfo.city || '',
    district: branchInfo.district || '',
    countryCode: branchInfo.countryCode || ''
  };

  try {
    // Create a payload with ONLY the branch info to update
    // This avoids any interference with other fields
    const payload = {
      branchInfo: cleanBranchInfo
    };
    
    console.log('[BranchInfoService] Sending payload:', JSON.stringify(payload, null, 2));
    
    // استرجاع التوكن من جلسة المستخدم
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    
    console.log('[BranchInfoService] التوكن المستخدم:', token ? 'موجود' : 'غير موجود');
    
    // Make the request with explicit headers including authorization
    const response = await fetch(`/api/invoices/pages/${pageId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
        'x-auth-token': token || ''
      },
      body: JSON.stringify(payload)
    });
    
    // Check if the request was successful
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`[BranchInfoService] API Error (${response.status}):`, errorText);
      throw new Error(`Failed to update branch info: ${response.status} ${response.statusText}`);
    }
    
    // Parse the response
    const data = await response.json();
    console.log('[BranchInfoService] Update response:', data);
    
    // Check for success message in response - structure might vary
    if (data.success === false) {
      console.error('[BranchInfoService] API reported failure:', data.message);
      throw new Error(`API reported failure: ${data.message}`);
    }
    
    // Get the page data from wherever it might be in the response structure
    let updatedPage = null;
    if (data.data && data.data.page) {
      updatedPage = data.data.page;
    } else if (data.page) {
      updatedPage = data.page;
    } else if (data.data) {
      updatedPage = data.data;
    }
    
    // If we found page data but it doesn't have branch info, add it back
    if (updatedPage && !updatedPage.branchInfo) {
      console.log('[BranchInfoService] Adding branch info to response:', cleanBranchInfo);
      updatedPage.branchInfo = cleanBranchInfo;
    }
    
    // Return whatever page data we have, even if incomplete
    return updatedPage || { branchInfo: cleanBranchInfo };
    
  } catch (error) {
    console.error('[BranchInfoService] Error updating branch info:', error);
    throw error;
  }
};

export const getBranchInfo = async (pageId) => {
  console.log(`[BranchInfoService] Getting branch info for page ${pageId}`);
  try {
    // استرجاع التوكن من جلسة المستخدم
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    
    console.log('[BranchInfoService] التوكن المستخدم للاسترجاع:', token ? 'موجود' : 'غير موجود');
    
    const response = await fetch(`/api/invoices/pages/${pageId}`, {
      headers: {
        'Accept': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
        'x-auth-token': token || ''
      }
    });
    
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`[BranchInfoService] API Error (${response.status}):`, errorText);
      throw new Error(`Failed to get page: ${response.status} ${response.statusText}`);
    }
    
    const data = await response.json();
    
    if (data.data && data.data.page) {
      const branchInfo = data.data.page.branchInfo || {
        branchName: '',
        companyName: '',
        commercialRegister: '',
        branchAddress: '',
        phoneNumber: '',
        taxNumber: ''
      };
      
      console.log('[BranchInfoService] Retrieved branch info:', branchInfo);
      return branchInfo;
    } else {
      console.warn('[BranchInfoService] Page data not found in response:', data);
      return null;
    }
  } catch (error) {
    console.error('[BranchInfoService] Error getting branch info:', error);
    throw error;
  }
};